export default "__VITE_ASSET__CWGbYZj8__"